
import { defineComponent, PropType } from "vue";
import { ChannelInfo } from "@/stores/telegramAlerts";

export default defineComponent({
  name: "AlertsFilters",
  props: {
    channels: {
      type: Array as PropType<ChannelInfo[]>,
      required: true,
    },
    selectedChannelId: {
      type: String as PropType<string | null>,
      default: null,
    },
    selectedMonth: {
      type: Number,
      required: true,
    },
    selectedYear: {
      type: Number,
      required: true,
    },
    months: {
      type: Array as PropType<string[]>,
      required: true,
    },
    years: {
      type: Array as PropType<number[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "select-channel",
    "update:selectedMonth",
    "update:selectedYear",
    "refresh",
  ],
});
